export const PipeImportModuleModels = {
  'Request': {
    'DynamicContent': 'RequestDynamicContent',
    'Get': 'RequestGet',
    'GetMultiple': 'RequestGetMultiple',
    'Upload': 'RequestUpload',
    'DiscoverSwiss': 'RequestDiscoverSwiss',
    'Ftp': 'RequestFtp',
    'Mongoose': 'RequestMongoose',
    'Website': 'RequestWebsite'
  },
  'Source': {
    'CSV': 'SourceCSV',
    'Excel': 'SourceExcel',
    'ics': 'SourceICS',
    'json': 'SourceJSON',
    'xml': 'SourceXML'
  },
  'Mapping': {
    'Default': 'MappingDefault'
  },
  'Order': {
    'Default': 'OrderDefault'
  },
  'CodeSnippet': {
    'Default': 'CodeSnippetDefault'
  },
  'Target': {
    'DynamicContent': 'TargetDynamicContent',
    'Redis': 'TargetRedis',
    'Mail': 'TargetMail',
    'FrontProfiles': 'TargetFrontProfiles'
  }
};
